import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
export default class AcuseOrdenCompra {
  // monedaDefault = "";
  // static totalSistema = 0;
  // static totalSistemaOtros = 0;
  // static subTotalProductos = 0;
  // static taxProductos = 0;
  // static totalPropinas = 0;
  // static totalPropinasOtros = 0;
  constructor() {}

  static getDocData(mainData) {
    let getTable = this.getTable(mainData.data, mainData.pageBreak);

    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",
      content: [
        // Encabezado
        {
          columns: [
            {
              width: "100%",
              alignment: "center",
              bold: true,
              fontSize: 16,
              text: [mainData.TITLE + "\n"],
            },
          ],
        },
        {
          columns: [
            {
              width: "35%",
              alignment: "left",
              bold: true,
              text: [
                "FECHA: " + mainData.FI + "\n",
                "DESC: " + (mainData.dsc || "Descripción no disponible") + "\n",
              ],
            },
            {
              width: "35%",
              alignment: "left",
              bold: true,
              text: [
                "ALMACEN: " +
                  (mainData.origen || "Almacén no disponible") +
                  "\n",
                "DEPTO: " +
                  (mainData.dpt || "Departamento no disponible") +
                  "\n",
              ],
            },
            {
              width: "30%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora Generado: " + mainData.HG + "\n",
              ],
            },
          ],
          columnGap: 10,
        },
        {
          columns: [
            {
              width: "100%",
              alignment: "left",
              fontSize: 13,
              text: ["\n" + (mainData.nts || "") + "\n"],
            },
          ],
        },
        {
          // Tabla principal de productos agrupados por proveedor
          table: {
            widths: ["*", "*", "auto"],
            body: getTable,
          },
          margin: [0, 10, 0, 0],
        },
      ],
    };

    return docDefinition;
  }

  static getTable(data, pageBreak) {
    // Encabezados de la tabla
    const headers = [
      { text: "Producto", border: [true, true, true, true], fontSize: 12 },
      { text: "Presentación", border: [true, true, true, true], fontSize: 12 },
      { text: "Cantidad", border: [true, true, true, true], fontSize: 12 },
    ];
  
    // Array para almacenar las secciones de la tabla
    const tables = [];
  
    // Iterar sobre cada grupo de productos por proveedor en `data`
    data.forEach((grupo, index) => {
      // Añadir el nombre del proveedor como una fila separada
      tables.push([
        {
          text: grupo.proveedor,
          bold: true,
          fontSize: 14,
          colSpan: 3,
          alignment: "center",
          margin: [0, 5, 0, 5],
          ...(index > 0 && pageBreak
            ? { pageBreak: "before" } // Salto de página antes de este grupo si `pageBreak` es true
            : {}),
        },
        {},
        {},
      ]);
  
      // Añadir cada producto del grupo como una fila
      grupo.items.forEach((prod) => {
        tables.push([
          {
            text: prod.producto.nombre || "Sin nombre",
            border: [true, true, true, true],
            fontSize: 12,
          },
          {
            text: prod.presentacion
              ? `${prod.presentacion.nom} - ${prod.rdm} ${prod.producto.unidadMedida}`
              : "Sin presentación",
            border: [true, true, true, true],
            fontSize: 12,
          },
          {
            text: pgsHelper.formatNumber(prod.cnt || 0),
            border: [true, true, true, true],
            fontSize: 12,
          },
        ]);
      });
    });
  
    // Retornar la estructura completa que contiene los encabezados y las filas
    return [headers, ...tables];
  }
  
}
